import { warn } from "../../log.js";
const MEDIA_TAILOR_URLS = {
  dev: "https://mt.dev-ssai-oneapp.nbcuni.com/",
  prod: "https://mt.ssai-oneapp.nbcuni.com"
};
const VAM_URLS = {
  dev: "https://stable-int-video-ads-module.ad-tech.nbcuni.com/v1/freewheel-params",
  prod: "https://video-ads-module.ad-tech.nbcuni.com/v1/freewheel-params",
  atp: "https://stubbed-nft-video-ads-module.ad-tech.nbcuni.com/v1/freewheel-params"
};
const CONVIVA_VALUES = {
  nbcnews: {
    devCustomerKey: "61a16fe47d5345ac124fee77eb07a2ed1a5b82ab",
    prodCustomerKey: "efcad85fded269f462c434c4c5f84654a17d4a77",
    gatewayUrl: "https://nbcsports-test.testonly.conviva.com/"
  },
  cnbc: {
    devCustomerKey: "5236d0980748b4d4e0ea4dec01db0a78006ad447",
    prodCustomerKey: "e12872de91aaca7a39095801bdf5f168d87912fa",
    gatewayUrl: "https://nbcu-central-test.testonly.conviva.com/"
  }
};
function getConvivaPlayerName(brand) {
  return `${brand}-cvsdk-web`;
}
function getConvivaCustomerKey(env = "prod", brand) {
  var _a, _b;
  if (!brand) {
    warn("brand is required to get conviva customer key");
    return null;
  } else if (!CONVIVA_VALUES[brand]) {
    warn(`brand ${brand} is not supported for conviva customer key`);
    return null;
  }
  return env === "dev" ? (_a = CONVIVA_VALUES == null ? void 0 : CONVIVA_VALUES[brand]) == null ? void 0 : _a.devCustomerKey : (_b = CONVIVA_VALUES == null ? void 0 : CONVIVA_VALUES[brand]) == null ? void 0 : _b.prodCustomerKey;
}
function getConvivaConfig(env, brand) {
  var _a;
  const ret = {
    enabled: true,
    config: {
      customerKey: "",
      enableAdInsights: true,
      gatewayUrl: ""
    }
  };
  if (env === "none") {
    ret.enabled = false;
    return ret;
  }
  const customerKey = getConvivaCustomerKey(env, brand);
  if (!customerKey) {
    ret.enabled = false;
  } else {
    ret.config = {
      customerKey,
      enableAdInsights: true,
      gatewayUrl: ""
    };
  }
  if (env === "dev") {
    ret.config.gatewayUrl = ((_a = CONVIVA_VALUES == null ? void 0 : CONVIVA_VALUES[brand]) == null ? void 0 : _a.gatewayUrl) ?? "invalidGatewayUrl";
  }
  return ret;
}
export {
  CONVIVA_VALUES,
  MEDIA_TAILOR_URLS,
  VAM_URLS,
  getConvivaConfig,
  getConvivaCustomerKey,
  getConvivaPlayerName };
//# sourceMappingURL=dist/components/CoreVideoPlayer/configs.js.map